import VerofreshRecord from './VerofreshRecord'

class ServiceProviderRecord extends VerofreshRecord {
}

export default ServiceProviderRecord
